export default __webpack_public_path__ + "static/media/svcbl-topup.c9964d5a.jpg";